'use client';
import React from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

const AppProjectSlider = ({ images }: any) => {
    const sliderSettings = {
        dots: false,
        className: 'slider variable-width',
        arrow: true,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        variableWidth: true,
    };

    return (
        <div className="section dark:bg-black relative section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-10">
                        <h2 className="text-primary mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Screens
                        </h2>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="relative client-testimonial-slider">
                    <Slider {...sliderSettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                        {images.map((image: any, index: number) => {
                            return (
                                <div key={index}>
                                    <div className="app-item w-[240px] min-w-[240px] border-[6px] border-black rounded-[20px] mx-4 lg:mx-[35px]">
                                        <Image
                                            src={image.attachments}
                                            alt="outline one"
                                            width={564}
                                            height={1018}
                                            className="img-fluid"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
};
export default AppProjectSlider;
